import { render, staticRenderFns } from "./BrandAnalysis.vue?vue&type=template&id=0f17b096&scoped=true"
import script from "./BrandAnalysis.vue?vue&type=script&lang=js"
export * from "./BrandAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BrandAnalysis.vue?vue&type=style&index=0&id=0f17b096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f17b096",
  null
  
)

export default component.exports